import React from 'react'
import styled from 'styled-components';
import { Wrapper } from '../ui/Wrapper/Wrapper';
import { Text } from '../ui/Typography/Typography';

const Card = styled(Wrapper)`
`;

const CardHead = styled(Wrapper)`
    padding: 8% 0 0 8%;
    border-bottom: 1px dashed ${props => props.color};
`;


const WrapperCard = styled(Wrapper)`
    background: ${({theme}) => theme.colors.main};
    border-radius: 10px;
    width: 100%;
    float: left;
    position: relative;
    backdrop-filter: blur(6px);
    &.card-0{
        border: 1px solid ${props => props.color};

        ${CardHead} ${Text}:first-child{
            color: ${props => props.color};
        }
    }
    &::after, &:after {
        content: '';
        background: ${props => props.color};
        width: 100%;
        height: 100%;
        filter: blur(20px);
        position: absolute;
        top: 15px;
        z-index: -1;
        border-radius: 10px;
        opacity: .1;
    }
`;

interface EditorialCardProps {
    title: string
    nextDay: string
    text: string
    color: string
    index: string
}


const EditorialCard: React.FC<EditorialCardProps> = (props) => {

    return (
        <WrapperCard className={`card-${props.index}`} color={props.color} margin={'15px 7px'}>
            {renderTextBox()}
        </WrapperCard>
    )


    function renderTextBox(){
        return (
            <Card>
                <CardHead padding={'10px 0px'} color={props.color} width={'100%'} flex align='baseline'>
                    <Text large white weight="700" margin="0 0 10px 10px">{props.title}</Text>
                </CardHead>
                <Wrapper padding={'8% 8%'}>
                    <Text white medium dangerouslySetInnerHTML={{__html: props.text}}/>
                </Wrapper>
            </Card>
        )
    }

}

export default EditorialCard;
